module.exports = __webpack_public_path__ + "img/u13.31f5de3e.png";